import { render } from "./DashboardBuildingCard.vue?vue&type=template&id=cde560c8"
import script from "./DashboardBuildingCard.vue?vue&type=script&lang=js"
export * from "./DashboardBuildingCard.vue?vue&type=script&lang=js"
script.render = render

export default script